module.exports = __webpack_public_path__ + "static/media/Elaine (Yiran) Li.f750550d.png";